import { render, staticRenderFns } from "./clueMarket.vue?vue&type=template&id=c527ef2c&scoped=true"
import script from "./clueMarket.vue?vue&type=script&lang=js"
export * from "./clueMarket.vue?vue&type=script&lang=js"
import style0 from "./clueMarket.vue?vue&type=style&index=0&id=c527ef2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c527ef2c",
  null
  
)

export default component.exports